import { CardUIExtension, ICardModel, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CdTechnicalDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdTechnicalDocumentationClientHelper';
import { Card, CardSection } from 'tessa/cards';
import { CdUIHelper } from '../CdUIHelper';
import { CdRdStages } from 'src/cdScripts/Helpers/CdRdStages';
import { ValidationResultType } from 'tessa/platform/validation';
import { CdDocStates } from 'src/cdScripts/Helpers/CdDocStates';

export class CdTechnicalDocumentationUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;
  private _disposerSelectRow: Function | null = null;

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
      context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID)) {
      return;
    }

    CdTechnicalDocumentationClientHelper.AvailableAndClearFields(context);
    CdTechnicalDocumentationClientHelper.ReferenceTableLogic(context, this._disposer);
    CdTechnicalDocumentationClientHelper.TechDocPagesTableLogic(context, this._disposerSelectRow);
  }

  public async saving(context: ICardUIExtensionContext) {
    let card: Card;
    if ((card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID)) {
      return;
    }
    if (await CdUIHelper.CheckCount(context) == false) {
      context.cancel = true;
    }
    if (await !CdGeneralDocumentationClientHelper.CheckEditSignedFile(card)) {
      context.cancel = true;
      return;
    }
    // TES-11902 Проверка обязательности поля "Подраздел РД"
    this.CheckRdSubdivisionMandatory(context);
  }

  public CheckRdSubdivisionMandatory(context: ICardUIExtensionContext) {
    let model: ICardModel = context.model;
    let card: Card = context.model.card;
    let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
    let rdSection: CardSection | undefined = card.sections.tryGet('PkRdProperties');

    if (!pdciSection || !rdSection) return;
    let stageID: number | undefined = pdciSection.fields.tryGet('StageID');
    let stateID: number | undefined = pdciSection.fields.tryGet('StateID');
    let rdSubdivisionID = rdSection.fields.tryGet('RdSubdivisionID');

    let isSubdivisionRequired: boolean = (stateID === CdDocStates.Project.id && stageID === CdRdStages.WorkingDocumentation &&  (!rdSubdivisionID || rdSubdivisionID === null) );

    if (isSubdivisionRequired) {
      context.validationResult.add(ValidationResultType.Error, "\"Подраздел РД\" обязателен для заполнения.");
    }

    let control = model.controls.get("RdSubdivisionControl");
    if (control != null)
      control.isRequired = isSubdivisionRequired;
  }

  public finalized() {
    // подчищаем за собой
    if (this._disposer) {
      this._disposer();
      this._disposer = null;
    }
  }
}